import { render, staticRenderFns } from "./IssueLimit.vue?vue&type=template&id=1f6b4cf0&scoped=true&"
import script from "./IssueLimit.vue?vue&type=script&lang=js&"
export * from "./IssueLimit.vue?vue&type=script&lang=js&"
import style0 from "./IssueLimit.vue?vue&type=style&index=0&id=1f6b4cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b4cf0",
  null
  
)

export default component.exports